import React from "react";

interface ConfirmDeleteProps {
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
}

const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
  onConfirm,
  onCancel,
  message,
}) => {
  return (
    <>
      <div className="background-mask" onClick={() => onCancel()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onCancel()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>{message || "Are you sure you want to proceed?"}</h2>
          <div>This cannot be reversed. </div>
        </div>
        <div className="filter-actions">
          <button className="oxbtn btn-red" onClick={onConfirm}>
            Yes, I'm Sure
          </button>
          <button className="oxbtn btn-grey" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmDelete;
